angular.module('bmsApp.global').factory('NotificationSvc', function (CRUDSvc) {

	var enabled = true;

	var isEnabled = function () {
		return enabled === true;
	};

	var enable = function () {
		enabled = true;
	};

	var disable = function () {
		enabled = false;
	};

	return {
		getNotifications: function () {
			return CRUDSvc.get('api/notifications/get-notifications');
		},
		dismiss: function (Notification) {
			if (Notification.type == 'Activities\ActivitySchedule') {
				var data = Notification;
			}
			else {
				var data = {
					type: 'Notification',
					id: Notification.id
				};
			}
			return CRUDSvc.post('api/notifications/dismiss', data);
		},
		isEnabled: isEnabled,
		enable: enable,
		disable: disable
	};
});
